import { UserType } from './user';

/**
 * A server notification. Named `AppNotification` rather than `Notification` so it cannot be
 * confused with the DOM type of that name — the same reason `RepDocument` is not `Document`.
 */
export interface AppNotification {
  id: string;
  /** Set when addressed to one user; null for a role broadcast. */
  recipientId: string | null;
  /** Set for a role broadcast; null when addressed to one user. */
  recipientRole: UserType | null;
  message: string;
  /**
   * The JSON field really is `isRead`, not `read` — the server's Lombok-generated getter is
   * `getIsRead()`.
   *
   * A role broadcast is a single document with a single flag, so whichever admin marks it
   * read clears it for every admin. That is deliberate on the server side, which is why the
   * UI must only ever mark on an explicit click.
   */
  isRead: boolean;
  /** Id of whatever the notification is about, e.g. a payment record. */
  referenceId: string | null;
  /** Kind of thing `referenceId` points at, e.g. `PAYMENT_REQUEST`. */
  type: string | null;
  createdAt: string;
}

export const PAYMENT_REQUEST_NOTIFICATION = 'PAYMENT_REQUEST';
